<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#C9A84C"
    :border="true"
    inactive-color="#8A7A55"
    z-index="999"
    class="tabber_view"
  >
    <van-tabbar-item to="/Home">
      <span class="foorterTxt">{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home_active.png' : '/img/footer/home.png'"
          :alt="$t('foorter.index')"
          :class="{ 'ico-active': props.active, 'ico-muted': !props.active }"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Lottery">
      <span class="foorterTxt">{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/reserve.png' : '/img/footer/reserve.png'"
          :alt="$t('foorter.video')"
          :class="{ 'ico-active': props.active, 'ico-muted': !props.active }"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Choose">
      <span class="foorterTxt brandTxt"></span>
      <template #icon>
        <img
          :src="logoSrc"
          :alt="brandName"
          class="tui"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Video">
      <span class="foorterTxt">{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/video_active.png' : '/img/footer/video.png'"
          :alt="$t('foorter.subscribe')"
          :class="{ 'ico-active': props.active, 'ico-muted': !props.active }"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Mine">
      <span class="foorterTxt">{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/my_active.png' : '/img/footer/my.png'"
          :alt="$t('foorter.my')"
          :class="{ 'ico-active': props.active, 'ico-muted': !props.active }"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { resolveAssetUrl } from "../http";

const LOGO_FALLBACK = "/img/footer/beauty5.jpg";

export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  computed: {
    brandName() {
      const info = this.$store && this.$store.getters && this.$store.getters.getBaseInfo;
      return (info && info.name) || "남여사이";
    },
    logoSrc() {
      const info = this.$store && this.$store.getters && this.$store.getters.getBaseInfo;
      const ico = info && info.ico;
      return resolveAssetUrl(ico) || LOGO_FALLBACK;
    },
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "Lottery") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "choose") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "Lottery") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
.tabber_view{
  background-color: #000 !important;
  border-top: 1px solid rgba(201, 168, 76, 0.45);
}
.van-tabbar {
  height: @tabbar-height;
  background-color: #000 !important;
}
.van-tabbar-item__icon img {
  height: 9.5vw;
}
.ico-muted {
  opacity: 0.55;
  filter: sepia(1) saturate(2.2) hue-rotate(5deg) brightness(0.85);
}
.ico-active {
  opacity: 1;
  filter: sepia(1) saturate(3) hue-rotate(5deg) brightness(1.05);
}
.van-tabbar-item {
  font-size: 26px;
  background: transparent !important;
}
.foorterTxt {
  color: inherit;
}
.brandTxt {
  display: none;
}
.tui {
  width: 4.6rem;
  height: 4.6rem !important;
  margin-top: -8.5vw;
  background-color: #141414;
  border-radius: 50%;
  border: 10px solid #000;
  box-shadow: 0 0 0 2px rgba(201, 168, 76, 0.55);
  z-index: 10;
  object-fit: cover;
}
[class*="van-hairline"]::after {
  border: none !important;
}
::v-deep .van-tabbar-item--active{
  background-color: transparent;
}
::v-deep .van-tabbar-item--active .foorterTxt{
  color: #c9a84c;
}
::v-deep .van-tabbar {
  background: #000 !important;
}
</style>
